(function($) {

	$('.about-did-you-know .slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		infinite: true,
		prevArrow: $('.about-did-you-know .nav .prev'),
		nextArrow: $('.about-did-you-know .nav .next')
	});

	$('.about-history .slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		infinite: true,
		prevArrow: $('.about-history .nav .prev'),
		nextArrow: $('.about-history .nav .next')
	});

})(jQuery);